import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/estimation/new/metadata/')({
  beforeLoad: () => {
    throw redirect({ to: '/estimation/new/metadata/mandatory' });
  },
});
